import { useFlags } from 'config/useFlagsContext'
import { useConfiguracaoRndsQuery, useConfiguracaoSistemasExternosAtendimentoQuery } from 'graphql/hooks.generated'
import { TipoAtendimentoProfissional, TipoSistemaExternoEnum } from 'graphql/types.generated'

export function useAtendimentoHeaderConfig(cidadaoId: ID, tipoAtendimentoProfissional?: TipoAtendimentoProfissional) {
  const { PILOTO_SISTEMAS_EXTERNOS_ENABLED } = useFlags()

  const { data: configRnds } = useConfiguracaoRndsQuery()

  const {
    data: { hasIframes: hasIframesAtendimento },
  } = useConfiguracaoSistemasExternosAtendimentoQuery({
    variables: {
      input: {
        cidadaoId,
        tipoAtendimentoProfissional,
        tipoSistemaExterno: TipoSistemaExternoEnum.ATENDIMENTO,
      },
    },
    skip: !PILOTO_SISTEMAS_EXTERNOS_ENABLED || !tipoAtendimentoProfissional,
  })

  return { hasIframesAtendimento, configRnds }
}
